export default {
  select: {
    display: 'inline-block',
    height: '32px',
    backgroundColor: '#fff',
    fontSize: '16px',
    width: '300px',
    padding: '5px 10px',
    borderRadius: 0,
    WebkitAppearance: 'none'
  },
  container: {
    display: 'inline-block',
    position: 'relative'
  },
  svg: {
    position: 'absolute',
    height: '7.5px',
    width: '8px',
    right: '10px',
    top: '13px',
  },
  disabled: {
    cursor: 'not-allowed',
    border: '1px solid #ddd',
    borderColor: '#ddd',
    backgroundColor: '#ddd',
    color: '#aaa'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Select/style.js